<script>
import { authComputed } from "@/state/helpers";
import { company_type, contact_designation } from "@/helpers/global.variable";
import { required, email } from "vuelidate/lib/validators";
import errorHandler from "@/helpers/errorHandler";
import GuestService from "@/helpers/APIService/guest.service";

export default {
  data() {
    return {
      company_type,
      contact_designation,
      submitted: false,
      createError: false,
      errorMessage: null,
      isBtnLoading: false,
      mobile_code: "+1 ",
      contact_mobile_code: "+1 ",
      company: {
        name: "",
        mobile: "",
        mobile_iso: "US",
        email: "",
        country: "",
        state: "",
        city: "",
        zip_code: "",
        address_line_first: "",
        address_line_second: "",
        image: [],
        contact_designation: "",
        contact_email: "",
        contact_name: "",
        contact_mobile: "",
        contact_mobile_iso: "US",
        contract_doc: [],
        comment: "",
        company_type: "",
      },
      isSaveAndAddNew: false,
    };
  },
  components: {},
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  validations: {
    company: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  mounted() {
    this.setIfEdit();
  },
  methods: {
    setIfEdit() {
      if (this.currentProps.isEdit) {
        GuestService.getCompanyDetails(this.currentProps.selectedCompany.id)
          .then((response) => {
            if (response.mobile !== null) {
              response.mobile = response.mobile
                .trim()
                .substring(response.mobile.indexOf(" ") + 1);
            }
            if (response.contact_mobile !== null) {
              response.contact_mobile = response.contact_mobile
                .trim()
                .substring(response.contact_mobile.indexOf(" ") + 1);
            }
            this.company = response;
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
    // Method is use for save data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.company.mobile !== "" || null) {
        this.company.mobile = this.mobile_code + this.company.mobile;
      } else {
        this.company.mobile_iso = "US";
      }
      if (this.company.contact_mobile !== "" || null) {
        this.company.contact_mobile =
          this.contact_mobile_code + this.company.contact_mobile;
      } else {
        this.company.contact_mobile_iso = "US";
      }
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let companyData = new FormData();
        companyData.append("hotel", this.hotel.id);
        for (var key in this.company) {
          if (
            this.company[key] != "" &&
            this.company[key] != [] &&
            this.company[key] != "+91" &&
            this.company[key] != null
          ) {
            companyData.append(key, this.company[key]);
          }
          if (key === "image") {
            if (typeof this.company[key] === "string") {
              companyData.delete(key);
            }
          }
          if (key === "contract_doc") {
            if (typeof this.company[key] === "string") {
              companyData.delete(key);
            }
          }
        }

        if (this.currentProps.isEdit == false) {
          GuestService.createCompany(companyData)
            .then((company) => {
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", company);
              } else {
                this.$emit("submitted", company);
              }
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          GuestService.editCompany(
            this.currentProps.selectedCompany.id,
            companyData
          )
            .then((response) => {
              this.$emit("submitted", response);
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              errorHandler(error);
              this.isBtnLoading = false;
            });
        }
      }
    },
    // Method is use for close company
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    // Method is use for save and add new company continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    countryChange(phoneType, code) {
      if (phoneType === "mobile_number") {
        this.company.mobile_iso = code.iso2;
        this.mobile_code = "+" + code.dialCode + " ";
      } else {
        this.company.contact_mobile_iso = code.iso2;
        this.contact_mobile_code = "+" + code.dialCode + " ";
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h4>{{ this.currentProps.isEdit ? "Update" : "Add New" }} Company</h4>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <b-form-group class="mb-3" label="Name" label-for="company_name">
              <template slot="label">
                Company Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="company_name"
                type="text"
                placeholder="Company name"
                v-model="company.name"
                autocomplete="off"
                :class="{
                  'is-invalid': submitted && $v.company.name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.company.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.company.name.required"
                  >Company name is required.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <label class="form-label">Company Telephone </label>
            <vue-tel-input
              v-model="company.mobile"
              class="text-dark-gray"
              autoFormat
              :dropdownOptions="{
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                width: '390px',
                showSearchBox: true,
              }"
              @country-changed="countryChange('mobile_number', ...arguments)"
            ></vue-tel-input>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="company-name-input">
              <span slot="label">
                Email <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="company-name-input"
                type="email"
                v-model="company.email"
                :class="{
                  'is-invalid': submitted && $v.company.email.$error,
                }"
                autocomplete="off"
              ></b-form-input>
              <div
                v-if="submitted && $v.company.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.company.email.required">
                  Email is required.
                </span>
                <span v-if="!$v.company.email.email">Email is not valid.</span>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="country-name-input">
              <span slot="label"> Country </span>
              <b-form-input
                id="country-name-input"
                type="text"
                v-model="company.country"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="state-name-input">
              <span slot="label"> State </span>
              <b-form-input
                id="state-name-input"
                type="text"
                v-model="company.state"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="city-name-input">
              <span slot="label"> City </span>
              <b-form-input
                id="city-name-input"
                type="text"
                v-model="company.city"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="zip-code-name-input">
              <span slot="label"> Zip Code </span>
              <b-form-input
                id="zip-code-name-input"
                type="number"
                v-model="company.zip_code"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="address-1-name-input">
              <span slot="label"> Address Line 1 </span>
              <b-form-input
                id="address-1-name-input"
                type="text"
                v-model="company.address_line_first"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="address-2-name-input">
              <span slot="label"> Address Line 2 </span>
              <b-form-input
                id="address-2-name-input"
                type="text"
                v-model="company.address_line_second"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="company-type-input"
            >
              <span slot="label"> Company Type </span>
              <b-form-select
                class="form-select"
                id="company-type-input"
                v-model="company.company_type"
                :options="company_type"
              >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="company-image-input">
              <span slot="label"> Company Image </span>
              <b-form-file
                v-model="company.image"
                class="form-control"
                plain
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <h5 class="mt-3">CONTACT DETAILS</h5>
            <hr />
          </div>
          <div class="col-md-6">
            <b-form-group
              class="mb-3"
              label-for="company-contact_designation-input"
            >
              <span slot="label"> Designation </span>
              <b-form-select
                class="form-select"
                id="company-contact_designation-input"
                v-model="company.contact_designation"
                :options="contact_designation"
              >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="contact-name-input">
              <span slot="label"> Contact Person Name </span>
              <b-form-input
                id="contact-name-input"
                type="text"
                v-model="company.contact_name"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="contact-email-name-input">
              <span slot="label"> Email </span>
              <b-form-input
                id="contact-email-name-input"
                type="text"
                v-model="company.contact_email"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <label class="form-label">Contact Telephone</label>
            <vue-tel-input
              v-model="company.contact_mobile"
              class="text-dark-gray"
              autoFormat
              :dropdownOptions="{
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                width: '390px',
                showSearchBox: true,
              }"
              @country-changed="
                countryChange('contact_mobile_number', ...arguments)
              "
            ></vue-tel-input>
          </div>

          <div class="col-md-6">
            <b-form-group class="mb-3" label-for="contract-doc-input">
              <span slot="label"> Contract Doc </span>
              <b-form-file
                v-model="company.contract_doc"
                class="form-control"
                plain
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <h5 class="mt-3">COMMENTS</h5>
            <hr />
          </div>
          <div class="col-md-12">
            <b-form-group class="mb-3" label-for="comment-input">
              <b-form-textarea
                id="comment-input"
                placeholder="Enter Comments..."
                v-model="company.comment"
                autocomplete="off"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              v-if="this.currentProps.isEdit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{
                disabled: isSaveAndAddNew === true && isBtnLoading,
              }"
            >
              <i
                v-if="isSaveAndAddNew === true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end"
              @click="onSubmit"
              :class="{
                disabled: isSaveAndAddNew === false && isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isSaveAndAddNew === false && isBtnLoading"
              ></i>
              {{ currentProps.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
